'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJs = require('draft-js');

var _draftJsPluginsEditor = require('draft-js-plugins-editor');

var _draftJsPluginsEditor2 = _interopRequireDefault(_draftJsPluginsEditor);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _recompose = require('recompose');

var _lodash = require('lodash');

var _textEditorStoreConnector = require('../store/components/textEditorStoreConnector');

var _textEditorStoreConnector2 = _interopRequireDefault(_textEditorStoreConnector);

var _rICThrottle = require('../../../../common/utils/lib/rICThrottle');

var _rICThrottle2 = _interopRequireDefault(_rICThrottle);

var _forceBlur = require('../customRichUtils/forceBlur');

var _forceBlur2 = _interopRequireDefault(_forceBlur);

var _editorPropComparisons = require('./editorPropComparisons');

var _selectionUtils = require('../../../element/selection/selectionUtils');

var _createCompositeDecorator = require('../plugins/createCompositeDecorator');

var _createCompositeDecorator2 = _interopRequireDefault(_createCompositeDecorator);

var _textConstants = require('../textConstants');

require('draft-js/dist/Draft.css');

require('./MilanoteEditor.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Editor store


// Utils


// Plugins


// Constants


// Styles


exports.default = function (plugins, config) {
    var _class;

    // Used when the redux state updates outside of the user's edits
    var decorator = (0, _createCompositeDecorator2.default)(plugins);

    var MilanoteEditor = (0, _recompose.pure)(_class = (0, _textEditorStoreConnector2.default)(_class = function (_React$Component) {
        _inherits(MilanoteEditor, _React$Component);

        _createClass(MilanoteEditor, null, [{
            key: 'buildFromTextContent',
            value: function buildFromTextContent(textContent) {
                var contentState = (0, _lodash.isString)(textContent) ? _draftJs.ContentState.createFromText(textContent) : (0, _draftJs.convertFromRaw)(_extends({ entityMap: {}, blocks: [] }, textContent.toJS()));

                return _draftJs.EditorState.createWithContent(contentState, decorator);
            }
        }, {
            key: 'buildEditorState',
            value: function buildEditorState(textContent) {
                return textContent ? MilanoteEditor.buildFromTextContent(textContent) : _draftJs.EditorState.createEmpty(decorator);
            }
        }]);

        function MilanoteEditor(props) {
            _classCallCheck(this, MilanoteEditor);

            var _this = _possibleConstructorReturn(this, (MilanoteEditor.__proto__ || Object.getPrototypeOf(MilanoteEditor)).call(this, props));

            _initialiseProps.call(_this);

            var textContent = _this.props.textContent;

            var editorState = MilanoteEditor.buildEditorState(textContent);

            // These counts are used to determine whether enough changes have been made to force an update to the server.
            _this.lastSavedContent = editorState.getCurrentContent();

            _this.state = { editorState: editorState };
            return _this;
        }

        _createClass(MilanoteEditor, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.props.isEditing && this.editor) {
                    this.editor.focus();
                    this.onChange(_draftJs.EditorState.moveFocusToEnd(this.state.editorState));
                }
            }

            /**
             * Checks the next props to see if the component has changed from editing to not-editing, or vice versa.
             * If changing to editing the component will gain focus.
             * If changing to not-editing the component will fire the update action to save any changes.
             *
             * If there are changes to the components text content this will also update the editorState with those changes.
             */

        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ((0, _editorPropComparisons.stayedEditingElement)(this.props, nextProps) && (0, _editorPropComparisons.editorStateHasChanged)(this.props, nextProps)) {
                    this.setEditorState(nextProps.editorState);
                }

                if ((0, _editorPropComparisons.noLongerEditingThisEditor)(this.props, nextProps)) {
                    this.saveCurrentContent();
                }

                if ((0, _editorPropComparisons.stayedEditingElement)(this.props, nextProps)) {
                    return;
                }

                if ((0, _editorPropComparisons.noLongerEditingElement)(this.props, nextProps)) {
                    this.forceEditorBlur();
                    return;
                }

                if ((0, _editorPropComparisons.textContentHasChanged)(this.props, nextProps)) {
                    var editorState = MilanoteEditor.buildEditorState(nextProps.textContent);
                    this.lastSavedContent = editorState.getCurrentContent();
                    this.setEditorState(editorState);
                }
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(oldProps) {
                if ((0, _editorPropComparisons.startedEditingThisElement)(oldProps, this.props)) {
                    // The focus() is required by Firefox because it will not focus the editor DOM element if it's read
                    // only.  Thus we need to wait for the editor to become editable, then force focus to the editor and
                    // finally move the cursor to the end of the text area.
                    this.editor.focus();
                    this.onChange(_draftJs.EditorState.moveFocusToEnd(this.state.editorState));
                }
            }

            /**
             * Ensure all timers and updates are complete or flushed when unmounting component.
             */

        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                // Force save (and clear of timers) on unmount
                this.saveCurrentContent();
            }

            /**
             * Saves the new editor state to the internal state of this component, and also fires a Redux action to update
             * the current editors editorState.
             *
             * This is used so that updates made by the user while typing will be reflected in the view.
             */


            /**
             * Prevent the mouse down event from bubbling to the canvas so that the 'edit complete' action doesn't fire.
             */


            /**
             * Fires a redux action when this editor becomes focused so that the application can keep track of the editor that's
             * currently active.
             */


            // This is needed because draft is not blurring automatically when focus is moved to another editor

        }, {
            key: 'render',
            value: function render() {
                var _this2 = this;

                var _props = this.props,
                    isEditing = _props.isEditing,
                    isEditable = _props.isEditable,
                    className = _props.className;
                var editorState = this.state.editorState;


                var classes = {
                    editing: (0, _editorPropComparisons.currentlyEditingThisEditor)(this.props)
                };

                return _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('Editor', config.className, className, classes),
                        tabIndex: '-1',
                        onMouseDown: this.onMouseDown,
                        onClick: this.focusOnEditor },
                    _react2.default.createElement(_draftJsPluginsEditor2.default, _extends({ ref: function ref(c) {
                            _this2.editor = c;
                        }
                    }, this.props, {
                        saveCurrentContent: this.saveCurrentContent,
                        defaultBlockRenderMap: true,
                        editorState: editorState,
                        onChange: this.onChange,
                        onFocus: this.focusOnEditor,
                        readOnly: !(isEditable && isEditing),
                        plugins: plugins,
                        spellCheck: true }))
                );
            }
        }]);

        return MilanoteEditor;
    }(_react2.default.Component)) || _class) || _class;

    var _initialiseProps = function _initialiseProps() {
        var _this3 = this;

        this.onChange = function (editorState) {
            if (!_this3.props.isEditable) return;

            // The content has changed restart the debounce
            _this3.clearDebounceTimer();

            var currentContent = _this3.state.editorState.getCurrentContent();
            var newContent = editorState.getCurrentContent();

            var lastSavedBlockCount = _this3.lastSavedContent.getBlockMap().size;
            var newBlockCount = newContent.getBlockMap().size;

            // If the content has not changed a focus change has occurred
            // and if the content is not the same as the last saved content then it should be saved.
            // Or if a new line has been created or deleted then it should be saved.
            var contentHasChanged = currentContent !== newContent;
            var shouldSave = lastSavedBlockCount !== newBlockCount || !_this3.props.isEditing;
            if (shouldSave) {
                _this3.saveData(editorState);
            } else if (contentHasChanged) {
                _this3.changeDebounceTimer = setTimeout(function () {
                    return _this3.saveData(editorState);
                }, _textConstants.DEFAULT_SAVE_TIMEOUT);
            }

            _this3.props.editorStateChanged({ editorId: _this3.props.editorId, editorState: editorState });
        };

        this.onMouseDown = function (event) {
            if (_this3.props.isEditing) event.stopPropagation();
        };

        this.setEditorState = function (editorState) {
            _this3.setState({ editorState: editorState });
        };

        this.clearDebounceTimer = function () {
            if (_this3.changeDebounceTimer) clearTimeout(_this3.changeDebounceTimer);
            _this3.saveDataOnIdle.cancel();
        };

        this.saveData = function (editorState) {
            // If a timer is still running clear it
            _this3.clearDebounceTimer();

            var currentContent = editorState.getCurrentContent();
            // Don't save if the last saved content is the same as the currently saved content
            if (_this3.lastSavedContent === currentContent) return;
            _this3.lastSavedContent = currentContent;

            var saveContent = _this3.props.saveContent;


            var textContent = (0, _draftJs.convertToRaw)(currentContent);

            // Defer the saving of content until CPU time is available
            saveContent && saveContent(textContent);
        };

        this.saveDataOnIdle = (0, _rICThrottle2.default)(this.saveData);

        this.focusOnEditor = function (event) {
            var editorKey = _this3.props.editorKey;

            if ((0, _selectionUtils.isAttemptingMultiSelect)(event) || (0, _editorPropComparisons.currentlyEditingThisEditor)(_this3.props)) return;

            _this3.props.startEditing(editorKey);
        };

        this.forceEditorBlur = function () {
            // This doesn't seem to do anything as far as setting the editor state, it just feels correct
            _this3.editor.blur();
            var updatedEditorState = (0, _forceBlur2.default)(_this3.state.editorState);
            // Don't need all the onChange checks for this state
            _this3.setEditorState(updatedEditorState);
        };

        this.saveCurrentContent = function () {
            _this3.saveData(_this3.state.editorState);
        };
    };

    MilanoteEditor.propTypes = {
        editorState: _propTypes2.default.object,
        editorId: _propTypes2.default.string.isRequired,
        editorKey: _propTypes2.default.string.isRequired,
        textContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
        className: _propTypes2.default.string,
        isEditing: _propTypes2.default.bool,
        isEditable: _propTypes2.default.bool,
        editorStateChanged: _propTypes2.default.func,
        saveContent: _propTypes2.default.func,
        startEditing: _propTypes2.default.func,
        stopEditing: _propTypes2.default.func
    };

    return MilanoteEditor;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/milanoteEditor/createMilanoteEditor.js
// module id = 682
// module chunks = 0